import Forms from "pages/Forms";
import Login from "pages/Login";
import Statistics from "pages/Statistics";
import { lazy } from "react";
import { BiSolidCalendarStar, BiSolidCategory } from "react-icons/bi";
import { FaWpforms } from "react-icons/fa6";
import { IoMdNotifications } from "react-icons/io";
import { IoPerson, IoStatsChart } from "react-icons/io5";
import { MdDashboardCustomize } from "react-icons/md";
import { TiHome } from "react-icons/ti";

const Dashboard = lazy(() => import("../pages/Dashboard"));
const Events = lazy(() => import("../pages/Events"));
const AddEditEvent = lazy(() => import("../pages/AddEditEvent"));
const Crud = lazy(() => import("../pages/Crud"));
const Cms = lazy(() => import("../pages/Cms"));
const Advertisment = lazy(() => import("../pages/Advertisement"));
const AccountSettings = lazy(() => import("../pages/AccountSettings"));
const Notifications = lazy(() => import("../pages/Notifications"));
const Repo = lazy(() => import("../pages/Repo"));
export const routes = [
  {
    path: "/login",
    exact: true,
    element: <Login />,
    protected: false,
    showInSidebar: false,
  },
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    icon: <TiHome />,
    element: <Dashboard />,
  },
  {
    path: "/events",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Events",
    icon: <BiSolidCalendarStar />,
    element: <Events />,
  },
  {
    path: "/event/create",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Create Event",
    element: <AddEditEvent />,
  },
  {
    path: "/event/edit/:slug",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Edit Event",
    element: <AddEditEvent />,
  },
  {
    path: "/statistics",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Statistics",
    icon: <IoStatsChart />,
    element: <Statistics />,
  },

  {
    path: "/repo",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Repo",
    element: <Repo />,
  },
  {
    path: "/forms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Forms",
    icon: <FaWpforms />,
    element: <Forms />,
  },
  {
    path: "/notifications",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Notifications",
    icon: <IoMdNotifications />,
    element: <Notifications />,
  },
  {
    path: "/crud",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "CRUD",
    element: <Crud />,
    icon: <BiSolidCategory />,
  },
  {
    path: "/cms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "CMS",
    element: <Cms />,
    icon: <MdDashboardCustomize />,
  },
  {
    path: "/advertisment",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Advertisment",
    element: <Advertisment />,
    icon: <MdDashboardCustomize />,
  },
  {
    path: "/account-settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Account Settings",
    icon: <IoPerson />,
    element: <AccountSettings />,
  },
];
